import { paddings } from 'core/styles';
import { device } from 'core/styles/variables';
import styled from 'styled-components';

export const DescriptionParagraph = styled.p`
  margin-top: -${paddings.mediumPadding};
  margin-bottom: -${paddings.mediumPadding};
`;

export const DescriptionAnchor = styled.a`
  color: ${({ theme }) => theme.colors.brandPrimary};

  &:visited {
    color: ${({ theme }) => theme.colors.brandPrimary};
  }
  &:hover {
    color: ${({ theme }) => theme.colors.orange600};
  }
`;

export const ApplicableSalesCompanyCodesUl = styled.ul`
  list-style: none;

  @media ${device.md} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    padding-left: 0;
  }
`;

export const ContainerDiv = styled.div`
  display: grid;
  grid-template-columns: 95px 1fr;
  line-height: 1.4;
  gap: ${paddings.defaultPadding};
  width: max-content;
`;

export const ButtonDiv = styled.div`
  display: flex;
  justify-content: end;
  margin-top: -${paddings.hugePadding};
`;
